/**
 * 系统菜单
 */
export default [
  {
    label: 'QXInvestment',
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-yonghu',
    id:1826,
    children: [
      {
        path: '/nbqx/index.action',
        label: 'statistics',
        permission: 'hr_emp_metashares',
        icon: 'icon-yonghu',
        id: 1826-1,
      },
    ]
  },
  {
    label: 'workbench',
    permission: 'home_page_menu',
    img: true,
    icon: 'icon-ic-zhuye',
    shortcut_icon: "bussiness-man",
    path: '/index',
    id:1,
  },
]
